var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Faq.tsx
import React from "react";
import { Accordion } from "@volvo-cars/react-accordion";
var Faq = ({ defaultExpanded, children }) => /* @__PURE__ */ React.createElement(Accordion, {
  defaultExpanded
}, children);

// src/SimpleFaqs.tsx
import React7 from "react";

// src/FaqsRenderer.tsx
import React3, { useEffect, useRef, useState } from "react";
import {
  AccordionController,
  Expand,
  useMediaQuery
} from "@volvo-cars/react-accordion";
import { useTranslate } from "@volvo-cars/react-shared-translations";
import { useTracker } from "@volvo-cars/tracking";
import { nanoid } from "nanoid";
import { View } from "vcc-ui";

// src/Descendants.ts
import { createDescendantsIndexContext } from "@volvo-cars/react-descendants";
var { useDescendantIndex, DescendantsIndexProvider } = createDescendantsIndexContext();

// src/ShowMoreButton.tsx
import React2 from "react";
import { Link } from "vcc-ui";
var ShowMoreButton = ({
  children,
  onClick,
  arrow,
  onKeyDown,
  "aria-expanded": ariaExpanded = false,
  showMoreKey
}) => {
  return /* @__PURE__ */ React2.createElement(Link, {
    arrow,
    "aria-expanded": ariaExpanded,
    "aria-controls": showMoreKey ? `${showMoreKey}-faq-details` : void 0,
    id: showMoreKey ? `${showMoreKey}-faq-button` : void 0,
    onClick: (event) => {
      event.preventDefault();
      onClick == null ? void 0 : onClick(event);
    },
    onMouseDown: (event) => event.preventDefault(),
    onKeyDown: (event) => {
      if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
        onKeyDown == null ? void 0 : onKeyDown(event);
        event.preventDefault();
      }
    }
  }, children);
};

// src/FaqsRenderer.tsx
var FaqsRenderer = ({ initialQas, hiddenQas, showMoreText, showLessText, multiple }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const expandRef = useRef(null);
  const [showMoreKey, setShowMoreKey] = useState("");
  useEffect(() => {
    setShowMoreKey(nanoid(8));
  }, []);
  showLessText = useTranslate("react-faqs.showLess", {
    disabled: !!showLessText
  }) || showLessText;
  showMoreText = useTranslate("react-faqs.showMore", {
    disabled: !!showMoreText
  }) || showMoreText;
  const reducedMotion = useMediaQuery("(prefers-reduced-motion)");
  const tracker = useTracker(null, { forceLowerCase: true }, {
    ignoreIfEmptyContext: true
  });
  return /* @__PURE__ */ React3.createElement(AccordionController, {
    multiple
  }, /* @__PURE__ */ React3.createElement(DescendantsIndexProvider, null, initialQas, hiddenQas ? /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement("div", {
    ref: expandRef,
    "aria-labelledby": showMoreKey ? `${showMoreKey}-faq-button` : void 0,
    id: showMoreKey ? `${showMoreKey}-faq-details` : void 0
  }, /* @__PURE__ */ React3.createElement(Expand, {
    isExpanded,
    animateOpacity: true,
    reducedMotion
  }, hiddenQas)), /* @__PURE__ */ React3.createElement(View, {
    extend: ({ theme: { baselineGrid } }) => ({
      paddingTop: 5 * baselineGrid,
      "& button": {
        textAlign: "center"
      }
    })
  }, /* @__PURE__ */ React3.createElement(ShowMoreButton, {
    "aria-expanded": isExpanded,
    showMoreKey,
    arrow: isExpanded ? "up" : "down",
    onClick: () => {
      tracker.interaction({
        eventAction: "click",
        eventLabel: isExpanded ? "show less" : "show more"
      });
      setIsExpanded((isExpanded2) => !isExpanded2);
    },
    onKeyDown: () => {
      tracker.interaction({
        eventAction: "click",
        eventLabel: isExpanded ? "show less" : "show more"
      });
      if (!isExpanded) {
        setTimeout(() => {
          var _a, _b;
          (_b = (_a = expandRef == null ? void 0 : expandRef.current) == null ? void 0 : _a.querySelector('[aria-controls$="-content"]')) == null ? void 0 : _b.focus();
        }, 50);
      }
      setIsExpanded((isExpanded2) => !isExpanded2);
    }
  }, isExpanded ? showLessText : showMoreText))) : null));
};

// src/RenderSimpleFaqs.tsx
import React6 from "react";
import { Text } from "vcc-ui";

// src/Answer.tsx
import React4 from "react";
import { AccordionDetails } from "@volvo-cars/react-accordion";
var Answer = ({
  children,
  "data-autoid": dataAutoId
}) => /* @__PURE__ */ React4.createElement(AccordionDetails, {
  "data-autoid": dataAutoId
}, children);

// src/Question.tsx
import React5 from "react";
import { AccordionSummary } from "@volvo-cars/react-accordion";
import { useTracker as useTracker2 } from "@volvo-cars/tracking";
var Question = ({ children, trackEventLabel, "data-autoid": dataAutoId }) => {
  const tracker = useTracker2(null, { forceLowerCase: true }, {
    ignoreIfEmptyContext: true
  });
  const { ref, index } = useDescendantIndex();
  return /* @__PURE__ */ React5.createElement(AccordionSummary, {
    ref,
    "data-autoid": dataAutoId,
    onInteraction: ({ expanded }) => {
      if (expanded) {
        tracker.interaction({
          eventAction: "click",
          eventLabel: trackEventLabel || `${index} | ${getTextContent(children)}`
        });
      }
    }
  }, children);
};
var getTextContent = (children) => {
  var _a;
  if (typeof children === "string")
    return children;
  const childTextNode = (_a = children == null ? void 0 : children.props) == null ? void 0 : _a.children;
  return typeof childTextNode === "object" ? getTextContent(childTextNode) : childTextNode;
};

// src/RenderSimpleFaqs.tsx
var RenderSimpleFaqs = ({ faqs }) => {
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, faqs == null ? void 0 : faqs.map(({ question, answer, defaultExpanded, trackEventLabel }, index) => /* @__PURE__ */ React6.createElement(Faq, {
    key: (question == null ? void 0 : question.toString()) + index.toString(),
    defaultExpanded
  }, /* @__PURE__ */ React6.createElement(Question, {
    trackEventLabel
  }, typeof question === "string" ? /* @__PURE__ */ React6.createElement(Text, {
    subStyle: "emphasis",
    variant: "columbus"
  }, question) : question), /* @__PURE__ */ React6.createElement(Answer, null, typeof answer === "string" ? /* @__PURE__ */ React6.createElement(Text, {
    variant: "columbus",
    extend: ({ theme: { color } }) => ({
      color: color.foreground.secondary,
      whiteSpace: "pre-line"
    })
  }, answer) : answer))));
};

// src/sortFaqs.ts
function sortFaqs(initialLength, faqs, defaultExpanded) {
  const initialFaqs = initialLength ? faqs == null ? void 0 : faqs.slice(0, initialLength) : faqs;
  const hiddenFaqs = initialLength ? [...faqs || []].splice(initialLength, faqs == null ? void 0 : faqs.length) : void 0;
  return {
    initialFaqs: defaultExpanded ? initialFaqs == null ? void 0 : initialFaqs.map((qa, index) => __spreadProps(__spreadValues({}, qa), {
      defaultExpanded: !!(defaultExpanded == null ? void 0 : defaultExpanded.includes(index))
    })) : initialFaqs,
    hiddenFaqs: defaultExpanded ? hiddenFaqs == null ? void 0 : hiddenFaqs.map((qa, index) => __spreadProps(__spreadValues({}, qa), {
      defaultExpanded: !!(defaultExpanded == null ? void 0 : defaultExpanded.includes(((initialFaqs == null ? void 0 : initialFaqs.length) || 0) + index))
    })) : hiddenFaqs
  };
}

// src/SimpleFaqs.tsx
var SimpleFaqs = (_a) => {
  var _b = _a, {
    faqs,
    initialLength,
    multiple = false,
    defaultExpanded
  } = _b, rest = __objRest(_b, [
    "faqs",
    "initialLength",
    "multiple",
    "defaultExpanded"
  ]);
  const { initialFaqs, hiddenFaqs } = sortFaqs(initialLength, faqs, defaultExpanded);
  if (!faqs || !faqs.length)
    return null;
  const initialFaqsNode = /* @__PURE__ */ React7.createElement(RenderSimpleFaqs, {
    faqs: initialFaqs
  });
  const hiddenFaqsNode = hiddenFaqs && hiddenFaqs.length ? /* @__PURE__ */ React7.createElement(RenderSimpleFaqs, {
    faqs: hiddenFaqs
  }) : null;
  return /* @__PURE__ */ React7.createElement(FaqsRenderer, __spreadValues({
    initialQas: initialFaqsNode,
    hiddenQas: hiddenFaqsNode,
    multiple
  }, rest));
};

// src/Faqs.tsx
import React8 from "react";
var Faqs = (_a) => {
  var _b = _a, {
    initialLength,
    children,
    multiple = false
  } = _b, rest = __objRest(_b, [
    "initialLength",
    "children",
    "multiple"
  ]);
  const faqs = Array.isArray(children) ? children : [children];
  const { initialFaqs, hiddenFaqs } = sortFaqs(initialLength, faqs);
  return /* @__PURE__ */ React8.createElement(FaqsRenderer, __spreadValues({
    initialQas: initialFaqs,
    hiddenQas: (hiddenFaqs == null ? void 0 : hiddenFaqs.length) ? hiddenFaqs : null,
    multiple
  }, rest));
};

// src/FaqStructuredData.tsx
import React9, { useMemo } from "react";
var FaqStructuredData = ({ faqs, faqPageId }) => {
  const jsonLd = useMemo(() => JSON.stringify(generateStructuredData(faqs, faqPageId)), [faqPageId, faqs]);
  return /* @__PURE__ */ React9.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: { __html: jsonLd }
  });
};
function generateStructuredData(faqs, faqPageId) {
  return __spreadProps(__spreadValues({
    "@context": "https://schema.org",
    "@type": "FAQPage"
  }, faqPageId && { "@id": faqPageId }), {
    mainEntity: faqs.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer
      }
    }))
  });
}
export {
  Answer,
  Faq,
  FaqStructuredData,
  Faqs,
  Question,
  SimpleFaqs,
  generateStructuredData
};
